<template>
  <div class="skin-green sidebar-mini">
    <div class="wrapper">
      <va-navibar></va-navibar>
      <va-slider></va-slider>
      <va-content-wrap style="background-color:#F6F6F6;"></va-content-wrap>
      <Modal></Modal>
    </div>
  </div>
</template>

<script>
import VANaviBar from '../navigation/NaviBar.vue'
import VASlider from '../navigation/Slider.vue'
import VAContentWrap from '../navigation/ContentWrap.vue'
import Modal from '../modal/Modal.vue'

export default {
  name: 'master',
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  components: {
    'va-navibar': VANaviBar,
    'va-slider': VASlider,
    'va-content-wrap': VAContentWrap,
    Modal
  }
}
</script>

<style type="text/CSS">
  @media (min-width: 320px) {
    .sidebar-mini.sidebar-collapse .main-sidebar {
      -webkit-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
      transform: translate(0, 0);
      width: 50px !important;
      z-index: 850;
      padding-top: 50px;
    }

    .sidebar-mini.sidebar-collapse .main-sidebar LI SPAN{
      display: none;
    }
  }
  
  @media (max-width: 790px) {
    div#content-wrap {
      margin-left: 50px;
    }
  }
</style>




// WEBPACK FOOTER //
// Master.vue?3f256acc